module.exports = [
    {
        path: "/mall/index",
        name: "mallIndex",
        meta: {
            title: "GoFun商城",
        },
        component: (resolve) =>
            require(["@/pages/mall/sell/pages/index.vue"], resolve),
    },
    {
        path: "/mall/address",
        name: "mallAddress",
        meta: {
            title: "地址管理",
        },
        component: (resolve) =>
            require(["@/pages/mall/sell/pages/address.vue"], resolve),
    },
    {
        path: "/mall/addAddress",
        name: "mallAddAddress",
        meta: {
            title: "地址管理",
        },
        component: (resolve) =>
            require(["@/pages/mall/sell/pages/addAddress.vue"], resolve),
    },
    // {
    //     path: "/mall/selling_goodsInfo",
    //     name: "mallgoodsInfo",
    //     meta: {
    //         title: "商品详情",
    //     },
    //     component: (resolve) =>
    //         require(["@/pages/mall/sell/pages/goodsInfo.vue"], resolve),
    // },
    {
        path: "/mall/makeOrder",
        name: "mallmakeOrder",
        meta: {
            title: "下单",
        },
        component: (resolve) =>
            require(["@/pages/mall/sell/pages/makeOrder.vue"], resolve),
    },
    {
        path: "/mall/orderList",
        name: "mallorderList",
        meta: {
            title: "订单列表",
        },
        component: (resolve) =>
            require(["@/pages/mall/sell/pages/orderList.vue"], resolve),
    },
    {
        path: "/mall/orderDetail",
        name: "mallorderDetail",
        meta: {
            title: "订单详情",
        },
        component: (resolve) =>
            require(["@/pages/mall/sell/pages/orderDetail.vue"], resolve),
    },
    {
        // 核销
        path: "/mall/verification",
        name: "verification",
        meta: {
            title: "核销工具",
        },
        component: (resolve) =>
            require(["@/pages/mall/verification/index.vue"], resolve),
    },
    {
        // 核销成功
        path: "/mall/success",
        name: "verificationSuccess",
        meta: {
            title: "核销工具",
        },
        component: (resolve) =>
            require(["@/pages/mall/verification/success.vue"], resolve),
    },
    {
        // 核销列表
        path: "/mall/verificationList",
        name: "verificationList",
        meta: {
            title: "核销工具",
        },
        component: (resolve) =>
            require(["@/pages/mall/verification/list.vue"], resolve),
    },

];



// WEBPACK FOOTER //
// src/pages/mall/sell/router-config.js